import { Expose, Transform, Type } from 'class-transformer'

import { Base } from './Base'
import { BarcodedUnit } from './BarcodedUnit'
import { Shipment } from './Shipment'

export class ShipmentBarcodedUnit extends Base {
  @Expose({ name: 'unit' })
  @Transform(({ unit }) => unit?.guid)
  guid: string = ''

  @Type(() => Shipment)
  shipment?: Shipment

  @Type(() => BarcodedUnit)
  unit?: BarcodedUnit
}
